import { render, staticRenderFns } from "./AlunoPage.vue?vue&type=template&id=22a42504&scoped=true&"
import script from "./AlunoPage.vue?vue&type=script&lang=js&"
export * from "./AlunoPage.vue?vue&type=script&lang=js&"
import style0 from "./AlunoPage.vue?vue&type=style&index=0&id=22a42504&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a42504",
  null
  
)

export default component.exports